import { LanguageTestQuestion } from '../../lib/types/models/language-test/language-test-question'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const deleteLanguageTestQuestion = (id: number) =>
  restApiClient
    .url(constructApiUrl(API.languageTest.deleteQuestion.url, { id }))
    .delete<LanguageTestQuestion>()
